import React, {useCallback} from 'react';
import EventListener from 'react-event-listener';

const BaseControl = ({catchKey, handler}) => {
    const handleKeyPress = useCallback(
        event => {
            const {activeElement} = document;

            if (activeElement instanceof HTMLInputElement) return false;

            const isKey = event.key === catchKey;

            if (isKey) event.preventDefault();

            return isKey;
        },
        [catchKey],
    );

    const handleKeyDown = useCallback(
        event => {
            handleKeyPress(event);
        },
        [handleKeyPress],
    );

    const handleKeyUp = useCallback(
        event => {
            if (handleKeyPress(event)) handler(event);
        },
        [handleKeyPress, handler]
    );

    return <EventListener target={window} onKeyDown={handleKeyDown} onKeyUp={handleKeyUp} />;
};

export default BaseControl;
